export const VerificationAgencyBase = `VerificationAgency`;

export const GetVaDetails = VerificationAgencyBase + '/GetVaDetails';
export const GetVaDetailsLinkedToSubmittedScorecard = VerificationAgencyBase + '/GetVaDetailsLinkedToSubmittedScorecard';
export const GetVerificationAgencies = VerificationAgencyBase + '/GetVerificationAgencies';
export const GetVerificationAgenciesWithConfig = VerificationAgencyBase + '/GetVerificationAgenciesWithConfig';